export default __webpack_public_path__ + "static/media/employees-outline-16px.92e01c77.svg";